document.addEventListener('DOMContentLoaded', function () {

                          
  //COMPARE PRODUCTS FUNCTIONALITY  
  
  let currentPath = window.location.pathname;
  console.log('currentPath', currentPath);
  
  //function to get all cookie by name
  function retriveCookie(cookie_name) {
     let name = cookie_name + '=';
     let cookies = decodeURIComponent(document.cookie).split(';');
     for (let i = 0; i<cookies.length; i++) {
        let c = cookies[i];
        while (c.charAt(0) == ' ') {
           c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
           // cookie.innerHTML = "The object in the cookies is -  " + c;
          return c;
        }
     }
  }
  
  //function to check and add cookie
  function checkAndAddCookie(productObj, productIdDelete){
    //console.log('checkAndAddCookie productObj', productObj);
    //console.log('checkAndAddCookie productIdDelete', productIdDelete);

    let now = new Date();
    let time = now.getTime();
    let expireTime = time + 2000*36000;
    now.setTime(expireTime);
    //console.log('now.toUTCString()', now.toUTCString());
    
     //get cookie
     let productsForComparison = retriveCookie("productsForComparison");
     if(productsForComparison){
       //console.log('cookie exist');
       // console.log('adding new item');
       let cookiedataforProdShowcase;
       
       let getCookieData = productsForComparison.split('productsForComparison=');
       // console.log('getCookieData split', getCookieData);       
       getCookieString = getCookieData[1];
       // console.log('getCookieString [1]', getCookieString);
       
       let getCookieJSON;
       let prodCount = 0;
       if(getCookieString.includes('-----')){
         //console.log('in if')
         let prodArr = getCookieString.split('-----');
         //console.log('prodArr', prodArr);
         //extract list data from Array and show it to the compare modal
         if(prodArr){
           cookiedataforProdShowcase = prodArr;
           let newEle = '';
           prodArr.forEach(function(pdarrEle){
             prodCount += 1;
             let prod_item = JSON.parse(pdarrEle);
             newEle += `<div class="product_c_info">
                          <div class="compare_image">
                            <img src="${prod_item.prod_img}" alt="${prod_item.prod_title}" class="comp_images">
                          </div>
                          <div class="compare_title">
                            <a href="/products/${prod_item.prod_handle}/" class="a_title"><h4>${prod_item.prod_title}</h4></a>
                            <p class="compare_price">${prod_item.prod_price}</p>
                          </div>
                          <div class="delete_icon" data-prod-id="${prod_item.prod_id}">
                            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512">
                              <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"></path>
                            </svg>
                          </div>
                        </div>`;
           });
           document.querySelector('#compareProductsList').innerHTML = newEle;           
           document.querySelector('#productsCount').textContent = prodCount;
         }
       }else{
         //console.log('in else');
         getCookieJSON = JSON.parse(getCookieString);
         //console.log('getCookieJSON', getCookieJSON);
         //extract single data from Object and show it to the compare modal
         if(getCookieJSON){
           cookiedataforProdShowcase = getCookieJSON;
           let newEle = `<div class="product_c_info">
                          <div class="compare_image">
                            <img src="${getCookieJSON.prod_img}" alt="${getCookieJSON.prod_title}" class="comp_images">
                          </div>
                          <div class="compare_title">
                            <a href="/products/${getCookieJSON.prod_handle}/" class="a_title"><h4>${getCookieJSON.prod_title}</h4></a>
                            <p class="compare_price">${getCookieJSON.prod_price}</p>
                          </div>
                          <div class="delete_icon" data-prod-id="${getCookieJSON.prod_id}">
                            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512">
                              <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"></path>
                            </svg>
                          </div>
                        </div>`;
           document.querySelector('#compareProductsList').innerHTML = newEle;
           document.querySelector('#productsCount').textContent = '1';        
         }
       }
         
       let prod_var_id = '*****';       
       if(productObj){
         for (const key in productObj) {
          if(key == 'prod_variant_id'){
            prod_var_id = productObj[key];
            //console.log('prod_var_id', prod_var_id);
          }
         }
         //console.log('prod_var_id', prod_var_id);
       }
       
       //check if product exist in cookie - If not add new product to this exixting cookie
       if(productsForComparison.includes(prod_var_id)){
           //console.log('prod exist in cookie');      
       }else{
         //console.log('prod doesnt exist in cookie');
         if(productObj){
           //console.log('So updating it');
           if(prodCount == 3){
             alert('You can only compare a maximum of three products at a time');                          
           }
           if(prodCount <= 2){
             document.cookie = 'productsForComparison=' + getCookieString + '-----' + JSON.stringify(productObj) + '; path=/; expires='+now.toUTCString()+';';
             //after updating the cookie - re-run this function to get and append products
             checkAndAddCookie();
           }
         }
       }

       //show compare btn popup
       document.querySelector('#compareModalToggleBtn').classList.add('active');


       //if compare page then show the data
       if( currentPath.includes('/products') || currentPath.includes('/collections') || currentPath.includes('/') || currentPath.includes('/search')){         
         document.querySelector('#compareModalToggleBtn').classList.add('active');
         //document.querySelector('#compareModal').classList.add('active');
       }else{
         document.querySelector('#compareModalToggleBtn').classList.remove('active');
         document.querySelector('#compareModal').classList.remove('active');
       }

       if( currentPath.includes('/compare-products') ){     
         document.querySelector('#compareModalToggleBtn').classList.remove('active');
         document.querySelector('#compareModal').classList.remove('active');
         showProductsData(cookiedataforProdShowcase);
       }
       

       //delete product from cookie  
       let allDeleteBtns = document.querySelectorAll('#compareProductsList .delete_icon');
       if(allDeleteBtns){
         allDeleteBtns.forEach(function(delEle){
           delEle.addEventListener('click', function(){
             let product_id = delEle.getAttribute('data-prod-id');
             //console.log('delete product_id', product_id)
             checkAndAddCookie('', product_id);
           });
         });
       }
        
       if(productIdDelete){
         deleteProductsFromCookie(cookiedataforProdShowcase, productIdDelete, now);
       }
         
   }else{
     //console.log('cookie not found');
     //hide compare btn popup
     document.querySelector('#compareModalToggleBtn').classList.remove('active');
     document.querySelector('#compareModal').classList.remove('active');
       
     if( currentPath.includes('/compare-products') ){         
       showProductsData();
     }
       
     if(productObj){
       //console.log('creating new cookie');
       document.cookie = 'productsForComparison=' + JSON.stringify(productObj) + '; path=/; expires='+now.toUTCString()+';';
       //after creating a new cookie - re-run this function to get and append products
       checkAndAddCookie();
     }
   }

  }


  
  
  //add product to - productsForComparison
  // let addProductToCompare = document.querySelector('#addProductToCompare');
  // if(addProductToCompare){
  //   addProductToCompare.addEventListener('click', function(e){
      
  //    //get the product data
  //    let data_id = addProductToCompare.getAttribute('data-id');
  //    let data_variant_id = addProductToCompare.getAttribute('data-variant-id');
  //    let data_handle = addProductToCompare.getAttribute('data-handle');
  //    let data_title = addProductToCompare.getAttribute('data-title');
  //    let data_price = addProductToCompare.getAttribute('data-price');
  //    let data_image = addProductToCompare.getAttribute('data-image');
      
  //    //create an Obj
  //    let productObj = { 
  //                   "prod_id": `${data_id}`,
  //                   "prod_variant_id": `${data_variant_id}`,
  //                   "prod_handle": `${data_handle}`,
  //                   "prod_title": `${data_title}`,
  //                   "prod_img": `${data_image}`,
  //                   "prod_price": `${data_price}`
  //                 };
      
  //     //check and add cookie
  //     checkAndAddCookie(productObj);      
  //     // document.querySelector('#compareModalToggleBtn').classList.add('active');
      
  //   });
  // }

  let addProductToCompareBTNS = document.querySelectorAll('.product-btn.compare');
  // console.log('addProductToCompareBTNS', addProductToCompareBTNS);
  if(addProductToCompareBTNS){
    addProductToCompareBTNS.forEach(function(addProdCompareBtnEle){
      addProdCompareBtnEle.addEventListener('click', function(e){
        
       //get the product data
       let data_id = addProdCompareBtnEle.getAttribute('data-id');
       let data_variant_id = addProdCompareBtnEle.getAttribute('data-variant-id');
       let data_handle = addProdCompareBtnEle.getAttribute('data-handle');
       let data_title = addProdCompareBtnEle.getAttribute('data-title');
       let data_price = addProdCompareBtnEle.getAttribute('data-price');
       let data_image = addProdCompareBtnEle.getAttribute('data-image');
        
       //create an Obj
       let productObj = { 
                      "prod_id": `${data_id}`,
                      "prod_variant_id": `${data_variant_id}`,
                      "prod_handle": `${data_handle}`,
                      "prod_title": `${data_title}`,
                      "prod_img": `${data_image}`,
                      "prod_price": `${data_price}`
                    };
        
        //check and add cookie
        checkAndAddCookie(productObj);      
        // document.querySelector('#compareModalToggleBtn').classList.add('active');
        
      });
    });
  }
  
 
  
  //delete product from cookie 
  function deleteProductsFromCookie(productsInCookie, productToDelete, expiryDate){
    //console.log('productsInCookie', productsInCookie);
    //console.log('productToDelete', productToDelete);

    //check if cookie is an array of products
    let isCookieArr = Array.isArray(productsInCookie);
    //console.log('isCookieArr', isCookieArr);
    if(isCookieArr){
      let newString = '';
      productsInCookie.forEach(function(cEle, cInd){
        let prod_item = JSON.parse(cEle);
        let splitter = '-----';
        if(prod_item.prod_id != productToDelete){
          newString += `${splitter}${cEle}`;
        }
      });
      //console.log('new item to add to cookie', newString);
      let updatedString = newString.slice(5);
      //console.log('updatedString', updatedString);
      //create a new cookie and replace original
      document.cookie = `productsForComparison=${updatedString}; path=/; expires=${expiryDate.toUTCString()};`;
      //update compare modal
      checkAndAddCookie();
    }else{
      //its a single json - delete cookie
      let prod_id = '';
      for (const key in productsInCookie) {
       if(key == 'prod_id'){
         prod_id = productsInCookie[key];
         //console.log('prod_var_id', prod_var_id);
       }
      }
      if(prod_id == productToDelete){
        document.cookie = 'productsForComparison=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
        //console.log('cookie deleted');
        //update compare modal
        checkAndAddCookie();
      }
    }
    
    
  }
  //delete product from cookie ends

  
  
  //show products data - Compare page
  async function showProductsData(cookiedataforProdShowcase){
    //console.log('showProductsData init', cookiedataforProdShowcase);
    
    if(cookiedataforProdShowcase){      
      //console.log('in if');
      //check if cookie is an array of products
      let isCookieArr = Array.isArray(cookiedataforProdShowcase);
      //console.log('isCookieArr', isCookieArr);
      if(isCookieArr){
                
        let products_info_col_string = `<td></td>`;
        let products_title_col_string = `<td>Name</td>`;
        let products_desc_col_string = `<td>Description</td>`;
        let products_standard_features_col_string = `<td>Standard Features</td>`;        
        let products_specific_features_col_string = `<td>Specific Features</td>`;
        let products_short_desc_col_string = `<td>Short Description</td>`;
        let products_sku_col_string = `<td>SKU</td>`;

        let psf_arr = [];
        
        //loop through products in cookie and get all the data        
        for(prodEle of cookiedataforProdShowcase){
          let prod_item = JSON.parse(prodEle);
          try {      
            
            //fetch product data
            await fetch(`/products/${prod_item.prod_handle}.json`)
              .then(response => response.json())
              .then(async (prod_res) => {
                
                 let prod_res_data = prod_res.product;
                // console.log('Prod Fetch:', prod_res_data);
                
                 //collect all necessary details 
                 let p_id = prod_res_data.id;
                 let p_variant_id = '';
                 let p_title = prod_res_data.title;
                 let p_image = prod_res_data.image.src;
                 let p_description = prod_res_data.body_html;
                 let p_price = '';
                 let p_sku = '';
                 let p_availability = '';
                 //get variants price and SKU
                 prod_res_data.variants.forEach(function(e){
                   if(e.id == prod_item.prod_variant_id){
                     p_variant_id = e.id
                     p_price = `$${e.price}`;
                     p_sku = e.sku;
                   }
                 });
                
                 let p_standard_features = '';
                 let p_specific_features = '';
                 let p_additional_resources = '';
                
                  //fetch metafield data 
                  await fetch(`/admin/api/2024-01/products/${prod_item.prod_id}/metafields.json`, {
                      method:'GET', 
                      headers: {'Authorization': 'Basic ' + btoa('f4cd534d01158495ce426fc8996fdcfc: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')}
                    })
                    .then(response => response.json())
                    .then(meta_res => {

                      let prod_meta_data = meta_res.metafields;
                      //console.log('Metafield Fetch Data:', prod_meta_data);
                      
                      prod_meta_data.map(function(mEle){
                        if(mEle.namespace == 'custom'){
                          if(mEle.key == 'standard_features'){
                            p_standard_features += mEle.value;                              
                          }
                          if(mEle.key == 'additional_resources'){
                            p_additional_resources = mEle.value;                              
                          }
                        }
                        if(mEle.namespace == 'product'){
                          if(mEle.key != 'Spec_Sheet' && mEle.key != 'User_Manual'  && mEle.key != 'Warranty' && mEle.key != 'Videos' ){
                            let key = mEle.key;
                            key = key.replace('_', ' ');
                            let val = mEle.value;
                            //p_specific_features += `<b>${key}</b> : ${val} <br>`;
                            
                            let tempArr = [];
                            tempArr.push(val);
                            let tempObj = {
                              key: key,
                              value: tempArr
                            };
                            //console.log('tempObj', tempObj);
                            psf_arr.push(tempObj);
                            
                          }
                        }
                      });
                      
                    });//metafield fetch ends
              
                //create col for info td                
                products_info_col_string += `<td>
                    <div class="product_block">
                      <img src="${ p_image }">
                      <h3>${ p_title }</h3>
                      <span class="price">${ p_price }</span>
                      <form class="product_form" action="/cart/add?id=${ p_variant_id };quantity=1" method="post">
                        <button role="button" class="btn btn-primary btn-block a-submit">
                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                            <path d="M14.3069 2.87629C14.2258 2.76006 14.0954 2.68822 13.9536 2.68217L5.16567 2.30337C4.91353 2.29233 4.70282 2.487 4.69204 2.73797C4.68133 2.98884 4.87567 3.20081 5.12661 3.21159L13.3196 3.56477L11.7087 8.59093H4.53993L3.24479 1.53898C3.21632 1.38443 3.1102 1.25549 2.96386 1.19807L0.84264 0.364731C0.608854 0.273201 0.345045 0.388033 0.253231 0.621533C0.161574 0.85516 0.276375 1.11913 0.510033 1.21094L2.39614 1.9519L3.71413 9.12762C3.75386 9.34333 3.94186 9.50001 4.16129 9.50001H4.37992L3.88068 10.8867C3.83889 11.0029 3.8561 11.1319 3.92722 11.2328C3.99823 11.3338 4.11373 11.3938 4.23703 11.3938H4.5872C4.37022 11.6353 4.23703 11.9533 4.23703 12.3029C4.23703 13.0549 4.84888 13.6666 5.60068 13.6666C6.35248 13.6666 6.96433 13.0549 6.96433 12.3029C6.96433 11.9533 6.83114 11.6353 6.61419 11.3938H9.5873C9.37022 11.6353 9.23706 11.9533 9.23706 12.3029C9.23706 13.0549 9.84876 13.6666 10.6007 13.6666C11.3527 13.6666 11.9644 13.0549 11.9644 12.3029C11.9644 11.9533 11.8312 11.6353 11.6143 11.3938H12.0401C12.2494 11.3938 12.4189 11.2242 12.4189 11.0151C12.4189 10.8058 12.2494 10.6363 12.0401 10.6363H4.776L5.18504 9.49989H12.0401C12.2378 9.49989 12.4127 9.37218 12.4729 9.18412L14.3669 3.2749C14.4104 3.14004 14.388 2.99258 14.3069 2.87629ZM5.60071 12.9091C5.26646 12.9091 4.99463 12.6373 4.99463 12.3031C4.99463 11.9688 5.26646 11.697 5.60071 11.697C5.93497 11.697 6.20676 11.9688 6.20676 12.3031C6.20676 12.6373 5.93497 12.9091 5.60071 12.9091ZM10.6007 12.9091C10.2665 12.9091 9.99466 12.6373 9.99466 12.3031C9.99466 11.9688 10.2665 11.697 10.6007 11.697C10.935 11.697 11.2068 11.9688 11.2068 12.3031C11.2068 12.6373 10.935 12.9091 10.6007 12.9091Z" fill="white" stroke="white" stroke-width="0.0888889" ></path>
                          </svg> 
                          Add to cart 
                        </button>
                      </form>
                    </div>
                  </td>`;
                
                //create col for Name td                
                products_title_col_string += `<td>${p_title}</td>`;

                //create col for Description td                
                products_desc_col_string += `<td>${p_description}</td>`;

                //create col for Standard Features td
                products_standard_features_col_string += `<td>${p_standard_features}</td>`;

                //create col for Specific Features td
                //products_specific_features_col_string += `<td>${p_specific_features}</td>`;
                
                //create col for Short description td                
                products_short_desc_col_string += `<td>${p_additional_resources}</td>`;

                //create col for SKU td                
                products_sku_col_string += `<td>${p_sku}</td>`;
                
              });//product fetch ends
            
          }catch(error) {
              console.log('Prod Fetch error: ', error);
          }
        }

        let compareTable = document.querySelector('#compare-products-data');
        if(compareTable){          
          compareTable.querySelector('#rowProductData').innerHTML = products_info_col_string;
          compareTable.querySelector('#rowProductTitle').innerHTML = products_title_col_string;
          // compareTable.querySelector('#rowProductDescription').innerHTML = products_desc_col_string;
          compareTable.querySelector('#rowProductStandardFeatures').innerHTML = products_standard_features_col_string;
          compareTable.querySelector('#rowProductSpecificFeatures').innerHTML = products_specific_features_col_string;
          compareTable.querySelector('#rowProductShortDescription').innerHTML = products_short_desc_col_string;
          compareTable.querySelector('#rowProductSKU').innerHTML = products_sku_col_string;
        }

        
        //console.log('psf_arr', psf_arr);

        function mergeObjectsByKey(arr) {
          const result = [];        
          arr.forEach((obj) => {
            const existingObj = result.find((item) => item.key === obj.key);        
            if (existingObj) {
              // If the key already exists, merge the values
              existingObj.value.push(...obj.value);
            } else {
              // If the key doesn't exist, add a new object to the result array
              result.push({ key: obj.key, value: [...obj.value] });
            }
          });        
          return result;
        }
        
        const mergedArray = mergeObjectsByKey(psf_arr);
        console.log('mergedArray', mergedArray);
        
        mergedArray.forEach(function(mrgEle, mrgInd){
          let row_pos = mrgInd + 5;
          let newRow = compareTable.insertRow(row_pos);
          let first_cell = newRow.insertCell(0);
          first_cell.innerHTML = mrgEle.key;
          mrgEle.value.forEach(function(mrgValEle, mrgValInd){                        
            let val_pos = mrgValInd + 1;
            let next_cell = newRow.insertCell(val_pos);
            if(mrgValEle.includes('https')){
              next_cell.innerHTML = `<a href="${mrgValEle}" target="blank" class="compare-download-btn">Download</a>`;
            }else{
              next_cell.innerHTML = mrgValEle;
            }
          });
        });
        
        

        
      }else{   
            //single product

            let products_info_col_string = `<td></td>`;
            let products_title_col_string = `<td>Name</td>`;
            let products_desc_col_string = `<td>Description</td>`;
            let products_standard_features_col_string = `<td>Standard Features</td>`;       
            let products_specific_features_col_string = `<td>Specific Features</td>`;
            let products_short_desc_col_string = `<td>Short Description</td>`;
            let products_sku_col_string = `<td>SKU</td>`;            
                 
            let psf_arr = [];
          
            try {     
              
              //fetch product data
              let prod_handle_single = cookiedataforProdShowcase['prod_handle'];
              let prod_id_single = cookiedataforProdShowcase['prod_id'];
              let prod_variant_id_single = cookiedataforProdShowcase['prod_variant_id'];
              
              await fetch(`/products/${prod_handle_single}.json`)
                .then(response => response.json())
                .then(async (prod_res) => {
                  
                   let prod_res_data = prod_res.product;
                   //console.log('Prod Fetch:', prod_res_data);
                  
                   //collect all necessary details 
                   let p_id = prod_res_data.id;
                   let p_variant_id = '';
                   let p_title = prod_res_data.title;
                   let p_image = prod_res_data.image.src;
                   let p_description = prod_res_data.body_html;
                   let p_price = '';
                   let p_sku = '';
                   let p_availability = '';
                   //get variants price and SKU
                   prod_res_data.variants.forEach(function(e){
                     if(e.id == prod_variant_id_single){
                       p_variant_id = e.id;
                       p_price = `$${e.price}`;
                       p_sku = e.sku;
                     }
                   });
                  
                  
                   let p_standard_features = '';
                   //let p_specific_features = '';
                   let p_additional_resources = '';
                  
                    //fetch metafield data 
                    await fetch(`/admin/api/2024-01/products/${prod_id_single}/metafields.json`, {
                        method:'GET', 
                        headers: {'Authorization': 'Basic ' + btoa('f4cd534d01158495ce426fc8996fdcfc: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')}
                      })
                      .then(response => response.json())
                      .then(meta_res => {
  
                        let prod_meta_data = meta_res.metafields;
                        //console.log('Metafield Fetch Data:', prod_meta_data);
                        
                        prod_meta_data.map(function(mEle){
                          if(mEle.namespace == 'custom'){
                            if(mEle.key == 'standard_features'){
                              p_standard_features += mEle.value;                              
                            }
                            if(mEle.key == 'additional_resources'){
                              p_additional_resources = mEle.value;                              
                            }
                          }
                          if(mEle.namespace == 'product'){
                            if(mEle.key != 'Spec_Sheet' && mEle.key != 'User_Manual'  && mEle.key != 'Warranty' && mEle.key != 'Videos' ){
                              let key = mEle.key;
                              key = key.replace('_', ' ');
                              let val = mEle.value;
                              //p_specific_features += `<b>${key}</b> : ${val} <br>`;
                              
                              let tempArr = [];
                              tempArr.push(val);
                              let tempObj = {
                                key: key,
                                value: tempArr
                              };
                              //console.log('tempObj', tempObj);
                              psf_arr.push(tempObj);
                              
                            }
                          }
                        });
                        
                      });//metafield fetch ends
                  
                  //create col for info td                
                  products_info_col_string += `<td>
                      <div class="product_block">
                        <img src="${ p_image }">
                        <h3>${ p_title }</h3>
                        <span class="price">${ p_price }</span>
                        <form class="product_form" action="/cart/add?id=${ p_variant_id };quantity=1" method="post">
                          <button role="button" class="btn btn-primary btn-block a-submit">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                              <path d="M14.3069 2.87629C14.2258 2.76006 14.0954 2.68822 13.9536 2.68217L5.16567 2.30337C4.91353 2.29233 4.70282 2.487 4.69204 2.73797C4.68133 2.98884 4.87567 3.20081 5.12661 3.21159L13.3196 3.56477L11.7087 8.59093H4.53993L3.24479 1.53898C3.21632 1.38443 3.1102 1.25549 2.96386 1.19807L0.84264 0.364731C0.608854 0.273201 0.345045 0.388033 0.253231 0.621533C0.161574 0.85516 0.276375 1.11913 0.510033 1.21094L2.39614 1.9519L3.71413 9.12762C3.75386 9.34333 3.94186 9.50001 4.16129 9.50001H4.37992L3.88068 10.8867C3.83889 11.0029 3.8561 11.1319 3.92722 11.2328C3.99823 11.3338 4.11373 11.3938 4.23703 11.3938H4.5872C4.37022 11.6353 4.23703 11.9533 4.23703 12.3029C4.23703 13.0549 4.84888 13.6666 5.60068 13.6666C6.35248 13.6666 6.96433 13.0549 6.96433 12.3029C6.96433 11.9533 6.83114 11.6353 6.61419 11.3938H9.5873C9.37022 11.6353 9.23706 11.9533 9.23706 12.3029C9.23706 13.0549 9.84876 13.6666 10.6007 13.6666C11.3527 13.6666 11.9644 13.0549 11.9644 12.3029C11.9644 11.9533 11.8312 11.6353 11.6143 11.3938H12.0401C12.2494 11.3938 12.4189 11.2242 12.4189 11.0151C12.4189 10.8058 12.2494 10.6363 12.0401 10.6363H4.776L5.18504 9.49989H12.0401C12.2378 9.49989 12.4127 9.37218 12.4729 9.18412L14.3669 3.2749C14.4104 3.14004 14.388 2.99258 14.3069 2.87629ZM5.60071 12.9091C5.26646 12.9091 4.99463 12.6373 4.99463 12.3031C4.99463 11.9688 5.26646 11.697 5.60071 11.697C5.93497 11.697 6.20676 11.9688 6.20676 12.3031C6.20676 12.6373 5.93497 12.9091 5.60071 12.9091ZM10.6007 12.9091C10.2665 12.9091 9.99466 12.6373 9.99466 12.3031C9.99466 11.9688 10.2665 11.697 10.6007 11.697C10.935 11.697 11.2068 11.9688 11.2068 12.3031C11.2068 12.6373 10.935 12.9091 10.6007 12.9091Z" fill="white" stroke="white" stroke-width="0.0888889" ></path>
                            </svg> 
                            Add to cart 
                          </button>
                        </form>
                      </div>
                    </td>`;
                  
                  //create col for Name td                
                  products_title_col_string += `<td>${p_title}</td>`;
  
                  //create col for Description td                
                  products_desc_col_string += `<td>${p_description}</td>`;
  
                  //create col for Standard Features td
                  products_standard_features_col_string += `<td>${p_standard_features}</td>`;

                  //create col for Specific Features td
                  //products_specific_features_col_string += `<td>${p_specific_features}</td>`;
                  
                  //create col for Short description td                
                  products_short_desc_col_string += `<td>${p_additional_resources}</td>`;
  
                  //create col for SKU td                
                  products_sku_col_string += `<td>${p_sku}</td>`;
                  
                });//product fetch ends
                
            }catch(error) {
                console.log('Prod Fetch error: ', error);
            }
                   
            let compareTable = document.querySelector('#compare-products-data');
            if(compareTable){          
              compareTable.querySelector('#rowProductData').innerHTML = products_info_col_string;
              compareTable.querySelector('#rowProductTitle').innerHTML = products_title_col_string;
              // compareTable.querySelector('#rowProductDescription').innerHTML = products_desc_col_string;
              compareTable.querySelector('#rowProductStandardFeatures').innerHTML = products_standard_features_col_string;
              compareTable.querySelector('#rowProductSpecificFeatures').innerHTML = products_specific_features_col_string;
              compareTable.querySelector('#rowProductShortDescription').innerHTML = products_short_desc_col_string;
              compareTable.querySelector('#rowProductSKU').innerHTML = products_sku_col_string;
            }

            //console.log('psf_arr', psf_arr);
    
            function mergeObjectsByKey(arr) {
              const result = [];        
              arr.forEach((obj) => {
                const existingObj = result.find((item) => item.key === obj.key);        
                if (existingObj) {
                  // If the key already exists, merge the values
                  existingObj.value.push(...obj.value);
                } else {
                  // If the key doesn't exist, add a new object to the result array
                  result.push({ key: obj.key, value: [...obj.value] });
                }
              });        
              return result;
            }
            
            const mergedArray = mergeObjectsByKey(psf_arr);
            //console.log('mergedArray', mergedArray);
            
            mergedArray.forEach(function(mrgEle, mrgInd){
              let row_pos = mrgInd + 5;
              let newRow = compareTable.insertRow(row_pos);
              let first_cell = newRow.insertCell(0);
              first_cell.innerHTML = mrgEle.key;
              mrgEle.value.forEach(function(mrgValEle, mrgValInd){                        
                let val_pos = mrgValInd + 1;
                let next_cell = newRow.insertCell(val_pos);
                // next_cell.innerHTML = mrgValEle;
                if(mrgValEle.includes('https')){
                  next_cell.innerHTML = `<a href="${mrgValEle}" target="blank" class="compare-download-btn">Download</a>`;
                }else{
                  next_cell.innerHTML = mrgValEle;
                }
              });
            });
        
        
        }//else ends
        
      
      document.querySelector('#productsDataWrap').style.display = 'block';
      document.querySelector('#noProductsToCompare').style.display = 'none';
      
    }else{
      
      //no products found
      document.querySelector('#productsDataWrap').style.display = 'none';
      document.querySelector('#noProductsToCompare').style.display = 'flex';
      
    }
    
  }
  //show products data - Compare page ends



  
  let compareModalToggleBtn = document.querySelector('#compareModalToggleBtn');
  if(compareModalToggleBtn){
    compareModalToggleBtn.addEventListener('click', function(){      
      document.querySelector('#compareModal').classList.toggle('active');
    });
  }

  
  
  //call on load
  checkAndAddCookie();

  //close search bas when clicked outside that element
  // onClickOutside('#compareModal', () => { 
  //   // console.log('Hello');
  //   document.querySelector('#compareModal').classList.remove('active');
  // });
  
  //COMPARE PRODUCTS FUNCTIONALITY ends


    
}, false);
